export enum JobType {
    Sync = "sync",
    Delete = "delete",
}

export type JobDescription = {
    id: string;
    type: JobType;
    numTiles: number;
    description: string;
    date: string;
    userData: any;
};

export type JobDeleteDescription = {
    id: string;
    jobId: string;
};

export abstract class JobQueueInterface {
    public abstract JOB_PROGRESS_EVENT: string;
    public abstract JOB_COMPLETE_EVENT: string;
    public abstract JOB_ABORTED_EVENT: string;
    public abstract JOB_DELETED_EVENT: string;
    public abstract JOB_STARTED_EVENT: string;
    public abstract JOB_ADDED_EVENT: string;

    public abstract name: string;

    public abstract init(): Promise<void>;
    public abstract reset(): Promise<void>;

    public abstract startJob(
        keys: string[],
        description: string,
        userData: any
    ): Promise<JobDescription>;
    public abstract deleteJob(id: string): Promise<void>;
    public abstract completedJobs(): Promise<JobDescription[]>;
    public abstract outstandingJobs(): Promise<JobDescription[]>;
    protected abstract _deleteJobCache(download: JobDescription): Promise<void>;
}
